class UserService {
  static instance = null;

  moduleAccess = [];

  userInfo = {};

  constructor() {
    if (UserService.instance) {
      // eslint-disable-next-line no-constructor-return
      return UserService.instance; // Return existing instance
    }
    UserService.instance = this;
  }

  static getInstance() {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }
    return UserService.instance;
  }

  setModuleAccess(moduleAccess) {
    this.moduleAccess = moduleAccess;
  }

  getModuleAccess() {
    return this.moduleAccess;
  }

  canAccessModule(module) {
    return this.moduleAccess.includes(module);
  }

  setUserInfo(userInfo) {
    this.userInfo = userInfo;
  }

  getUserInfo() {
    return this.userInfo;
  }

  getFullName() {
    const { givenName, familyName } = this.userInfo;
    if (givenName && familyName) {
      return `${givenName} ${familyName}`;
    }
    return givenName || familyName || '';
  }

  getEmail() {
    return this.userInfo.email || '';
  }
}

export default UserService;
